export class AuditInstanceFlowModel {
    xml:string = '';

    constructor(a?:Partial<AuditInstanceFlowModel>) {
        Object.assign(this, a);
    }
}
